import { createSelector } from 'reselect';
import memoize from 'lodash/memoize';
import flatten from 'lodash/flatten';
import { selectProductDetailsBySource } from 'yoda-site-components/lib/selectors/PdpNameSpaceSelector';

const getProductLotsSelector = (productDetails) => productDetails.lots || [];

// eslint-disable-next-line import/prefer-default-export
export const getProductSKUs = memoize((sourceMiniPDP) =>
    createSelector([selectProductDetailsBySource(sourceMiniPDP)], (productDetails) => {
        const productLots = getProductLotsSelector(productDetails);
        const productSKUs = flatten(
            productLots.map((lot) => {
                return lot.items.map((item) => item.id);
            })
        );
        return productSKUs;
    })
);
